import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungGoettingen() {
  return (
    <CityPageTemplate
      city="Göttingen"
      slug="goettingen"
      intro="In der Universitätsstadt Göttingen beraten wir Akademiker und Berufseinsteiger auf dem Weg zur finanziellen Freiheit."
      description="Unabhängige & digitale Finanzberatung für Göttingen: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
